import type { FC } from "react";

/** In-flight AI generation: pulsing text-shaped bars in the portal's AI
 *  gradient. Staggered widths on purpose — uniform blocks read as broken layout. */
export const GeneratingSkeleton: FC = () => (
  <div className="flex flex-col gap-2.5" role="status" aria-label="Generating">
    <div className="flex animate-pulse flex-col gap-2">
      {["w-full", "w-11/12", "w-full", "w-2/3"].map((width, i) => (
        <div key={i} className={`h-3 rounded ${width}`} style={{ backgroundImage: "var(--ai-skeleton-gradient)" }} />
      ))}
    </div>
  </div>
);
